import React from "react";
import { Box } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "tss-react/mui";
import "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useStyles = makeStyles()((theme) => ({
  root: {
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    border: `1px solid ${theme.palette.secondary.dark}`
  },
  checkedIcon: {
    background: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    boxSizing: "border-box",
    borderRadius: 3
  },
  checkedIconInner: {
    color: theme.palette.primary.contrastText,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: 0,
    margin: 0
  },
  styledCheckboxInput: {
    zIndex: "unset"
  }
}));
const StyledCheckbox = React.forwardRef(({ checkedIconType, ...props }, ref) => {
  const { classes, cx } = useStyles();
  const checkedIcon = getIcon("checkmark");
  const minusIcon = getIcon("minus");
  function getIcon(type) {
    return /* @__PURE__ */ React.createElement(Box, { className: cx(classes.checkedIcon, classes.icon) }, /* @__PURE__ */ React.createElement(Box, { component: "span", className: `${classes.checkedIconInner} ${type !== "minus" ? CustomIcon.Confirm : ""}`, fontSize: 9 }, type === "minus" ? "—" : ""));
  }
  return /* @__PURE__ */ React.createElement(
    Checkbox,
    {
      className: classes.root,
      disableRipple: true,
      color: "default",
      checkedIcon: checkedIconType === "minus" ? minusIcon : checkedIcon,
      icon: /* @__PURE__ */ React.createElement(Box, { className: classes.icon }),
      inputProps: { "aria-label": "decorative checkbox", className: classes.styledCheckboxInput },
      ...props,
      ref
    }
  );
});
export {
  StyledCheckbox
};
//# sourceMappingURL=StyledCheckbox.js.map
